import Component from "../abstracts/Component";

export default class LoginFormComponent extends Component {
  get SELECTORS() {
    return {
      headerLoginForm: 'headerLoginForm',
      cartLoginForm: 'cartLoginForm',
      loginLoginForm: 'LoginForm',
      emailError: ".emailError",
      passwordError: ".passwordError",
      email: "input[type='email']",
      password: "input[type='password']",
    };
  }

  get ERRORS_ATTRIBUTES() {
    return {
      emailBlank: "data-error-email-blank",
      passwordBlank: "data-error-password-blank",
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      headerLoginForm: document.getElementById(this.SELECTORS.headerLoginForm),
      cartLoginForm: document.getElementById(this.SELECTORS.cartLoginForm),
      LoginForm: document.getElementById(this.SELECTORS.loginLoginForm),
      email: document.getElementById(this.SELECTORS.email),
      password: document.getElementById(this.SELECTORS.password),
      emailError: this.$component.querySelector(this.SELECTORS.emailError),
      passwordError: this.$component.querySelector(
        this.SELECTORS.passwordError,
      ),
    };
  }

  checkFormValidity(event) {
    const currentTarget = this.dom[event.target.id];
    let isValid = true;
    const email = this.dom[event.target.id].querySelector(this.SELECTORS.email);
    const password = this.dom[event.target.id].querySelector(this.SELECTORS.password);
    const emailError = this.dom[event.target.id].querySelector(this.SELECTORS.emailError);
    const passwordError = this.dom[event.target.id].querySelector(this.SELECTORS.passwordError);

    this.MESSAGES = {
      email: {
        blank: currentTarget.getAttribute(this.ERRORS_ATTRIBUTES.emailBlank),
      },
      password: {
        blank: currentTarget.getAttribute(this.ERRORS_ATTRIBUTES.passwordBlank),
      },
    };

    let firstErrorField = null;

    // Clean up existing aria-describedby and error elements
    this.cleanupErrorElements(currentTarget);

    // Validate email first
    if (!email.value) {
      isValid = false;
      // Use the existing error element with aria-live
      this.showError(emailError, email, this.MESSAGES.email.blank);
      if (!firstErrorField) firstErrorField = email;
    } else {
      this.hideError(emailError, email);
    }

    // Validate password
    if (!password.value) {
      isValid = false;
      // Use the existing error element with aria-live
      this.showError(passwordError, password, this.MESSAGES.password.blank);
      if (!firstErrorField) firstErrorField = password;
    } else {
      this.hideError(passwordError, password);
    }

    // Focus on first error field
    if (!isValid) {
      if (firstErrorField) {
        firstErrorField.focus();
      }
      event.preventDefault();
    }
  }

  showError(errorElement, inputField, message) {
    // Set visual error message on the existing element
    errorElement.textContent = message;
    
    // Add error styling
    inputField.parentElement.classList.add("error");
    inputField.setAttribute("aria-invalid", "true");
    
    // Create ID for the existing error element if it doesn't exist
    if (!errorElement.id) {
      const fieldName = inputField.name === 'j_username' ? 'emailError' : 'passwordError';
      errorElement.id = fieldName;
    }
    
    // Link field to error element for screen readers
    inputField.setAttribute("aria-describedby", errorElement.id);
    
    // Use our dedicated temporary announcement element
    this.announceErrorToScreenReader(message);
  }

  announceErrorToScreenReader(message) {
    // Create a fresh temporary element for each announcement
    const announcement = document.createElement('div');
    announcement.setAttribute('aria-live', 'assertive');
    announcement.setAttribute('role', 'alert');
    announcement.className = 'sr-only';
    announcement.style.position = 'absolute';
    announcement.style.left = '-10000px';
    announcement.style.width = '1px';
    announcement.style.height = '1px';
    announcement.style.overflow = 'hidden';
    
    // Add to body
    document.body.appendChild(announcement);
    
    // Set message after a brief delay
    setTimeout(() => {
      announcement.textContent = message;
      
      // Remove the element after announcement
      setTimeout(() => {
        if (announcement.parentNode) {
          announcement.parentNode.removeChild(announcement);
        }
      }, 3000);
    }, 100);
  }

  hideError(errorElement, inputField) {
    // Clear error message
    errorElement.textContent = "";
    
    // Remove error styling
    inputField.setAttribute("aria-invalid", "false");
    inputField.parentElement.classList.remove("error");
    
    // Remove aria-describedby when there's no error
    inputField.removeAttribute("aria-describedby");
  }

  cleanupErrorElements(form) {
    // Clear existing error messages and reset states
    const errorElements = form.querySelectorAll('.--msg-error');
    errorElements.forEach(error => {
      error.textContent = '';
    });
    
    // Remove error states from all form fields
    const fields = form.querySelectorAll('input');
    fields.forEach(field => {
      field.setAttribute('aria-invalid', 'false');
      field.parentElement.classList.remove('error');
      field.removeAttribute('aria-describedby');
    });
  }

  bindEvents() {
    this.dom.headerLoginForm && this.dom.headerLoginForm.addEventListener("submit", this.checkFormValidity.bind(this));
    this.dom.cartLoginForm && this.dom.cartLoginForm.addEventListener("submit", this.checkFormValidity.bind(this));
    this.dom.LoginForm && this.dom.LoginForm.addEventListener("submit", this.checkFormValidity.bind(this));
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
